import { useEffect, useState, useMemo, useRef } from "react";
import styles from "./styles.module.css";
import * as React from "react";
import { Request } from "~types";
import { RequestComponent } from "~components/RequestComponent";
import { toast, ToastContainer } from "react-toastify";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { codes } from "~httpCodes";
import { Connection, ConnectionError } from "~Connection";
import { DomainDisplay } from "~components/DomainDisplay";

export default () => {
  // const [ws, setWs] = useState<WebSocket>();
  // const [domain, setDomain] = useState<string | null>(null);
  const [connection, setConnection] = useState<Connection>();
  const [requests, setRequests] = useState<Request[]>([]);
  const [connected, setConnected] = useState<boolean>(false);
  const [targetSubdomain, setTargetSubdomain] = useState<string>();
  const [responseCode, setResponseCode] = useState<string>("200");
  const [responseHeaders, setResponseHeaders] = useState<[string, string][]>([
    ["Content-Type", "text/plain"],
  ]);
  const [responseBody, setResponseBody] = useState<string>("");

  const handleIncomingRequest = (data: any) => {
    setRequests((old) => [
      ...old,
      {
        received: new Date(),
        count: 1,
        ...data,
      } as Request,
    ]);
  };

  useEffect(() => {
    Connection.new(
      handleIncomingRequest,
      () => {
        setConnected(false);
      },
      targetSubdomain
    ).then(
      (conn) => {
        connection?.close(false);
        setConnection(conn);
        setConnected(true);
      },
      (err) => {
        if (err instanceof ConnectionError) toast.error(err.message);
        else console.error(err);
      }
    );
  }, [targetSubdomain]);

  useEffect(() => {
    if (localStorage.getItem("response")) {
      try {
        const savedResponse = JSON.parse(
          localStorage.getItem("response") || ""
        );
        setResponseBody(savedResponse["body"]);
        setResponseHeaders(savedResponse["headers"]);
        setResponseCode(savedResponse["code"]);
      } catch {
        localStorage.removeItem("response");
      }
    }
  }, []);

  return (
    <>
      <h1>Requestbin</h1>
      <h2>
        {connection ? (
          <DomainDisplay
            subdomain={connection.subdomain}
            connected={connected}
            subdomainCallback={setTargetSubdomain}
          />
        ) : (
          "Getting a domain..."
        )}
      </h2>
      <p style={{ fontSize: 16 }}>
        Refreshing the page will generate a new bin and clear your current
        requests.
      </p>
      <Tabs focusTabOnClick={false}>
        <TabList>
          <Tab>Requests</Tab>
          <Tab>Response</Tab>
        </TabList>
        <TabPanel>
          <div className={styles.textMono}>
            {requests.length > 0 ? (
              requests.map((x) => <RequestComponent request={x} />)
            ) : (
              <p>Requests to your domain will appear here.</p>
            )}
          </div>
        </TabPanel>
        <TabPanel className={styles.responseTab}>
          <div className={styles.textMono}>
            <h3 style={{ display: "inline-block", width: 220 }}>
              Response code:
            </h3>
            <select
              value={responseCode}
              onChange={(e) => {
                connection?.updateResponse(
                  e.target.value,
                  responseHeaders,
                  responseBody
                );
                setResponseCode(e.target.value);
              }}
              disabled={!connected}
            >
              {Object.keys(codes).map((group) => (
                <optgroup label={group}>
                  {Object.keys(codes[group]).map((x) => (
                    <option value={x}>
                      {x}: {codes[group][x]}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
            <div>
              <h3 style={{ display: "inline-block", width: 220 }}>
                Response headers:
              </h3>
              <button
                disabled={!connected}
                onClick={() => {
                  const newHeaders: [string, string][] = [
                    ["name", "value"],
                    ...responseHeaders,
                  ];
                  connection?.updateResponse(
                    responseCode,
                    newHeaders,
                    responseBody
                  );
                  setResponseHeaders(newHeaders);
                }}
              >
                New header
              </button>
              {responseHeaders.length > 0 && (
                <table cellSpacing={8} style={{ marginBottom: 8 }}>
                  <thead>
                    <tr>
                      <th style={{ width: 40 }}></th>
                      <th style={{ width: 250, textAlign: "start" }}>
                        Header name
                      </th>
                      <th style={{ textAlign: "start" }}>Header value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseHeaders.map((x, i) => (
                      <tr>
                        <td>
                          <button
                            style={{ width: 40 }}
                            onClick={() => {
                              const newHeaders: [string, string][] = [
                                ...responseHeaders.slice(0, i),
                                ...responseHeaders.slice(i + 1),
                              ];
                              connection?.updateResponse(
                                responseCode,
                                newHeaders,
                                responseBody
                              );
                              setResponseHeaders(newHeaders);
                            }}
                            disabled={!connected}
                          >
                            🗑️
                          </button>
                        </td>
                        <td>
                          <input
                            type="text"
                            disabled={!connected}
                            value={x[0]}
                            onChange={(e) => {
                              const newHeaders: [string, string][] = [
                                ...responseHeaders.slice(0, i),
                                [e.target.value, responseHeaders[i][1]],
                                ...responseHeaders.slice(i + 1),
                              ];
                              connection?.updateResponse(
                                responseCode,
                                newHeaders,
                                responseBody
                              );
                              setResponseHeaders(newHeaders);
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            disabled={!connected}
                            style={{ minWidth: "30vw" }}
                            value={x[1]}
                            onChange={(e) => {
                              const newHeaders: [string, string][] = [
                                ...responseHeaders.slice(0, i),
                                [responseHeaders[i][0], e.target.value],
                                ...responseHeaders.slice(i + 1),
                              ];
                              connection?.updateResponse(
                                responseCode,
                                newHeaders,
                                responseBody
                              );
                              setResponseHeaders(newHeaders);
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              {}
            </div>
            <h3>Response content:</h3>
            <textarea
              rows={10}
              style={{ padding: 8 }}
              value={responseBody}
              onChange={(e) => {
                connection?.updateResponse(
                  responseCode,
                  responseHeaders,
                  e.target.value
                );
                setResponseBody(e.target.value);
              }}
              readOnly={!connected}
            ></textarea>
          </div>
        </TabPanel>
      </Tabs>
      <ToastContainer theme="dark" />
    </>
  );
};
